<template>
  <div class="invite-fans">
     <app-open
      class="app-open"
    >
    </app-open>
    <img class="banner" src="/images/vip/fans1.jpg" alt="" />
    <img class="title" src="/images/vip/fans2.jpg" alt="" />
    <div>
      <template v-for="(item,index) in auditionAlbumList">
        <invite-fans-item :active="playActive==index" :index="index" :album="item.album" :desc="item.description" :audition="auditionList[index]" @togglePlay="togglePlay" class="item" :key="index" @click="togglePlay(index)">
          <audio v-if="auditionList[index]" ref="audio" preload="meta" :src="auditionList[index].displayUrl"></audio>
        </invite-fans-item>
      </template>
    </div>
    <div class="show-container">
      <h3>更多亲子好课，尽在智伴优学VIP课程包</h3>
      <div class="content">
        <template v-for="(item,index) in showAlbumList">
          <router-link :key="index" :to="`/goods/detail/${item.id}`">
            <invite-fans-album class="albumItem" :album="item"></invite-fans-album>
          </router-link>
        </template>
      </div>
    </div>
    <button-bar mode="invite-fans" @bottomBarHandler="bottomBarHandler">
    </button-bar>
  </div>
</template>

<script>
import { AppOpenAlert as AppOpen } from '@/components/common'
import inviteFansItem from "@/components/vip/inviteFansItem";
import inviteFansAlbum from "@/components/vip/inviteFansAlbum";
import buttonBar from "@/components/goods/pkgButtonBar";
import { Config, LocalStorageUtil } from "@/utils";
import { wechatSharePkgPage } from "@/mixins/wechatShare.js";
export default {
  mixins: [wechatSharePkgPage],
  components: { inviteFansItem, inviteFansAlbum, buttonBar,AppOpen },
  created() {
    this.initData(this.$route.query.moduleId);
  },
  data() {
    return {
      playActive: -1,
      auditionList: [],
      auditionAlbumList: [],
      showAlbumList: []
    };
  },
  watch: {
    userInfo: {
      immediate: true,
      handler: function() {
        this.$setShareConfig(this.getShareText());
      }
    }
  },
  methods: {
    async initData(moduleId = 1) {
      if (moduleId) {
        moduleId = parseInt(moduleId);
        let {
          content: auditionAlbumList
        } = await this.$api.api_v3_invite_card_module_album_search_page_with_post(
          {
            data: { moduleId: moduleId, type: 0 },
            path: { pluses: "album" }
          }
        );
        this.auditionList.length = auditionAlbumList.length;
        this.auditionAlbumList = auditionAlbumList;
        for (let i = 0; i < auditionAlbumList.length; i++) {
          this.$api
            .api_v3_media_search_page_post({
              data: { albumId: auditionAlbumList[i].album.id }
            })
            .then(({ content: list }) => {
              this.$set(this.auditionList, i, list[0]);
            });
        }
        this.$api
          .api_v3_album_search_page_post({
            data: {
              inviteCardModuleId: moduleId,
              inviteCardModuleType: 1,
              pageSize: 6
            }
          })
          .then(({ content: showAlbumList }) => {
            this.showAlbumList = showAlbumList;
          });
      }
    },
    togglePlay(toggle, active) {
      console.info(this.$refs.audio);
      for (let index = 0; index < this.auditionAlbumList.length; index++) {
        if (index === active) {
          if (toggle) {
            this.playActive = active;
            this.$refs.audio[index].play();
          } else {
            this.playActive = -1;
            this.$refs.audio[index].pause();
          }
        } else {
          this.$refs.audio[index].pause();
        }
      }
    },
    login() {
      if (this.isNative) {
        this.$store.dispatch("externalInterface/navigateTo", {
          name: "login"
        });
      } else {
        this.$router.push("/account/login-bySMS");
      }
    },
    bottomBarHandler(flag) {
      if (flag == "vipDetail") {
        this.$router.push({
          path: "/goods/pkg"
        });
      } else if (flag == "login") {
        this.login();
      }
    },
    getShareTitle() {
      let name = this.getShareDesc();
      return `${name}邀您一起来智伴优学体验亲子学习好课！`;
    },
    getShareLink() {
      let contextId = "";
      if (!this.isWeak || this.isPlusMember) {
        contextId = this.selfInviteCode;
      } else {
        contextId = LocalStorageUtil.getContextId();
      }
      return `${process.env.VUE_APP_SHARE_URL}/share.html?path=/vip/inviteFans${
        contextId ? "&contextId=" + contextId : ""
      }`;
    }
  }
};
</script>

<style scoped>
.banner {
  display: block;
  width: 100vw;
}
.title {
  display: block;
  margin-top: 14px;
  width: 100vw;
}
.invite-fans {
  background: #fcfbfb;
  padding-bottom: 76px;
}
.item + .item {
  margin-top: 24px;
}
.albumItem {
  width: 94px;
  margin-bottom: 10px;
}
.show-container {
  width: 335px;
  background: #f4f8fa;
  border-radius: 12px;
  padding: 17px 0 10px;
  margin: 30px auto 0;
}
.show-container h3 {
  font-size: 14px;
  color: #244352;
  line-height: 20px;
  font-weight: bold;
  margin-bottom: 15px;
  padding-left: 16px;
}
.show-container .content {
  width: 302px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
}
</style>